export default __webpack_public_path__ + "static/media/01_Food_Safety_Guidelines.af46e8b7.pdf";